import React, { useState, useEffect } from "react";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import Fullcalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { GetComplianceCalendarPayloadType } from "../../commonTypes/complianceCalendarTypes";
import {
  getComplianceCalendarAction,
  resetComplianceCalendarError,
  resetComplianceCalendarFetching,
  resetComplianceCalendarList,
  resetComplianceCalendarMessage,
  resetComplianceCalendarStatusCode,
  resetComplianceCalendarSuccess,
} from "../../redux/complianceCalendar";
import { Overlay, Tooltip } from "react-bootstrap";
import "./calendar.scss";
import Select from "react-select";
import { DropDownType } from "../../commonTypes/clientDirectoryTypes";
import { GetAssignedClientsToUserPayloadType } from "../../commonTypes/authTypes";
import {
  getAssignedClientsToUserAction,
  resetAssignedClientsToUserList,
  resetAuthError,
  resetAuthMessage,
  resetAuthSuccess,
  resetSession,
} from "../../redux/auth";
import {
  CardLoader,
  CircularAvatar,
  Comments,
  CommonHeader,
  ContentArea,
  ErrorSuccessModal,
  Loader,
  TableLoader,
} from "../../components/commons";
import {
  currentDate,
  currentMonth,
  currentYear,
} from "../../utils/commonFunctions";
import Avatar from "../../components/commons/CircularAvatar/CircularAvatar";
import SkeltonElement from "../../components/commons/SkeltonLoader/SkeltonElement";
import { OverlayTrigger } from "react-bootstrap";
import { CalanderGrayIcon } from "../../assets/images";
import {
  GetAllDocumentsLinkPayloadType,
  GetJobProgressCommentsPayload,
} from "../../commonTypes/listing";
import {
  getJobCommentsDetailsAction,
  getJobLinksDetailsAction,
} from "../../redux/jobs";
import {
  DocumentsLinkType,
  JobProgressCommentType,
} from "../../redux/listing/listingTypes";
import {
  resetDocumentsLinkList,
  resetJobProgressCommentsListing,
  resetJobProgressCommentsSuccess,
} from "../../redux/listing";
import LinkDetails from "../../components/JobListing/LinkUploadModal/LinkDetails";
import { LoginResponseType } from "../../redux/auth/authTypes";

type TabsType = {
  name: string;
  label: string;
};

const tabs: TabsType[] = [
  {
    name: "All Comments",
    label: "allComments",
  },
  {
    name: "All Links",
    label: "allLink",
  },
];

type AppProps = {
  dispatchComplianceCalenderListData: (
    data: GetComplianceCalendarPayloadType
  ) => void;
  complianceCalendarList: [] | any;
  fetching: boolean;
  authFetching: boolean;
  message: string | null;
  error: string | null;
  authError: string | null;
  success: number | null;
  authSuccess: number | null;
  statusCode: number | null;
  authStatusCode: number | null;
  token: string | null;
  loginData: LoginResponseType;
  documentsLinkList: [] | DocumentsLinkType[];
  jobProgressCommentsFetching: boolean;
  jobProgressCommentsList: [] | JobProgressCommentType[];
  jobProgressCommentsSuccess: number | null;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  dispatchResetAuthError: () => void;
  assignedClientsToUserList: any;
  resetComplianceCalendarList: () => void;
  dispatchResetAuthSuccess: () => void;
  dispatchResetAuthMessage: () => void;
  dispatchResetSession: () => void;
  dispatchResetAssignedClientsToUserList: () => void;
  disptahcResetComplianceCalendarFetching: () => void;
  dispatchResetComplianceCalendarSuccess: () => void;
  dispatchResetComplianceCalendarMessage: () => void;
  dispatchResetComplianceCalendarStatusCode: () => void;
  dispatchResetComplianceCalendarError: () => void;

  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => void;
  dispatchGetDocumentsLinkAction: (
    data: GetAllDocumentsLinkPayloadType
  ) => void;
  dispatchResetJobProgressCommentsListing: () => void;
  dispatchResetJobProgressCommentsSuccess: () => void;
  dispatchResetDocumentsLinkList: () => void;
};
const ComplianceCalendar = ({
  dispatchComplianceCalenderListData,
  fetching,
  message,
  authFetching,
  error,
  success,
  statusCode,
  complianceCalendarList,
  token,
  loginData,
  documentsLinkList,
  jobProgressCommentsFetching,
  jobProgressCommentsList,
  jobProgressCommentsSuccess,
  dispatchGetAssignedClientsToUserAction,
  dispatchResetAuthError,
  assignedClientsToUserList,
  resetComplianceCalendarList,
  dispatchResetAuthSuccess,
  dispatchResetAuthMessage,
  dispatchResetSession,
  dispatchResetAssignedClientsToUserList,
  authSuccess,
  authStatusCode,
  authError,
  disptahcResetComplianceCalendarFetching,
  dispatchResetComplianceCalendarSuccess,
  dispatchResetComplianceCalendarMessage,
  dispatchResetComplianceCalendarStatusCode,
  dispatchResetComplianceCalendarError,
  dispatchGetAllJobProgressCommentsAction,
  dispatchGetDocumentsLinkAction,
  dispatchResetJobProgressCommentsListing,
  dispatchResetJobProgressCommentsSuccess,
  dispatchResetDocumentsLinkList,
}: AppProps) => {
  const [eventDetails, setEventDetails] = useState(false);
  const [monthData, setMonthData] = useState("");
  const [yearData, setYearData] = useState("");
  const [eventDetailsClick, setEventDetailsClick] = useState<any>({});
  const [eventData, setEventData] = useState([]);
  const [clientName, setClientName] = useState<any>({
    value: null,
    label: "Select Client..",
  });
  const [text, setText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [offset, setoffset] = useState<number>(0);
  const [finalClientList, setFinalClientList] = useState<any>([]);
  const [activeTab, setActiveTab] = useState(tabs[0].label);
  const showComments = eventDetailsClick?.data?.job_id
    ? eventDetailsClick?.data?.job_id
    : false;

  useEffect(() => {
    dispatchResetJobProgressCommentsListing();
    dispatchResetDocumentsLinkList();
  }, []);

  useEffect(() => {
    if (showComments) {
      setActiveTab("allComments");
      dispatchResetJobProgressCommentsListing();
      dispatchResetDocumentsLinkList();
      if (activeTab === "allComments") {
        let finalData: GetJobProgressCommentsPayload = {
          job_id: eventDetailsClick?.data?._id,
          token,
        };
        dispatchGetAllJobProgressCommentsAction(finalData);
      }
      if (activeTab === "allLink") {
        let finalData: GetAllDocumentsLinkPayloadType = {
          job_id: eventDetailsClick?.data?._id,
          token,
        };

        dispatchGetDocumentsLinkAction(finalData);
      }
    }
  }, [showComments, eventDetailsClick]);

  const handleClick = (e: any) => {
    setEventDetails(!eventDetails);
    setEventDetailsClick({ data: e?.event?._def?.extendedProps?.data });
    dispatchResetJobProgressCommentsListing();
    dispatchResetDocumentsLinkList();
  };

  useEffect(() => {
    resetComplianceCalendarList();
    dispatchResetAuthSuccess();
    dispatchResetAuthMessage();
    dispatchResetAssignedClientsToUserList();
    disptahcResetComplianceCalendarFetching();
    dispatchResetComplianceCalendarSuccess();
    dispatchResetComplianceCalendarMessage();
    dispatchResetComplianceCalendarStatusCode();
    dispatchResetComplianceCalendarError();
    dispatchResetAuthError();
    dispatchResetJobProgressCommentsListing();
    dispatchResetDocumentsLinkList();
  }, []);
  useEffect(() => {
    if (token) {
      let params = {
        token,
        user_id: loginData?.user_id,
      };
      dispatchGetAssignedClientsToUserAction(params);
      dispatchResetAuthError();
    }
  }, []);

  useEffect(() => {
    dispatchResetJobProgressCommentsListing();
    dispatchResetDocumentsLinkList();
    if (showComments) {
      if (activeTab === "allComments") {
        let finalData: GetJobProgressCommentsPayload = {
          job_id: eventDetailsClick?.data?._id,
          token,
        };
        dispatchGetAllJobProgressCommentsAction(finalData);
      }
      if (activeTab === "allLink") {
        let finalData: GetAllDocumentsLinkPayloadType = {
          job_id: eventDetailsClick?.data?._id,
          token,
        };

        dispatchGetDocumentsLinkAction(finalData);
      }
    }
  }, [activeTab]);

  useEffect(() => {
    if (!eventDetails) {
      setEventDetailsClick({});
    }
  }, [eventDetails]);

  useEffect(() => {
    const finalClientListData = assignedClientsToUserList?.map((data: any) => {
      return {
        value: data?.client_code,
        label: `(${data?.client_code}) ${data?.company_name}`,
      };
    });
    // if (offset > 0) {
    //   setFinalClientList([...finalClientList, ...finalClientListData]);
    // } else {
    // }
    setFinalClientList(finalClientListData);
  }, [assignedClientsToUserList]);

  function checkDueDateJob(dueDate: string) {
    let datCompare =
      dueDate?.split("-").join(",") < currentDate()?.split("-").join(",");
    return datCompare;
  }

  useEffect(() => {
    if (complianceCalendarList?.length > 0) {
      let eventArray: any = [];
      complianceCalendarList?.forEach((el: any) => {
        if (el?.jobs?.length > 0) {
          for (let i = 0; i < el?.jobs?.length; i++) {
            if (el?.jobs[i]?.job_status !== "Closed") {
              eventArray.push({
                date: el?.due_date,
                data: el?.jobs[i],
                // title: `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type?.length > 10 ? el?.jobs[i]?.job_type?.slice(0, 10) + "..." : el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`,
                title:
                  `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`
                    ?.length > 15
                    ? `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`?.slice(
                        0,
                        15
                      ) + "..."
                    : `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`,
                fullTitle: `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`,

                backgroundColor: checkDueDateJob(el?.due_date)
                  ? "#E0794A"
                  : "#2D7FE3",
                textColor: checkDueDateJob(el?.due_date) ? "white" : "white",
                //  color: "green",
                //  textColor:el?.jobs[i]?.job_status==="Closed"?"#e3efff":"#fde0d3",
                fontWeight: 500,
                borderColor: checkDueDateJob(el?.due_date)
                  ? "#E0794A"
                  : "#2D7FE3",
                cursor: "pointer",
              });
            } else if (el?.jobs[i]?.job_status === "Closed") {
              eventArray.push({
                date: el?.due_date,
                data: el?.jobs[i],
                // title: `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type?.length > 10 ? el?.jobs[i]?.job_type?.slice(0, 10) + "..." : el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`,
                title:
                  `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`
                    ?.length > 15
                    ? `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`?.slice(
                        0,
                        15
                      ) + "..."
                    : `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`,
                fullTitle: `${el?.jobs[i]?.job_id}_${el?.jobs[i]?.job_type}_${el?.jobs[i]?.period_ended}`,
                backgroundColor: "white",
                textColor: "#6E7491",
                fontWeight: 500,
                borderColor: "#BFCBE1",
                cursor: "pointer",
              });
            }
          }
        }
        if (el?.future_jobs?.length > 0) {
          for (let j = 0; j < el?.future_jobs?.length; j++) {
            eventArray.push({
              date: el?.due_date,
              data: el?.future_jobs[j],
              // title: `${el?.future_jobs[j]?.job_type?.length > 10 ? el?.future_jobs[j]?.job_type?.slice(0, 10) + "..." : el?.future_jobs[j]?.job_type}_${el?.future_jobs[j]?.period_ended}`,
              title:
                `${el?.future_jobs[j]?.job_type}_${el?.future_jobs[j]?.period_ended}`
                  ?.length > 15
                  ? `${el?.future_jobs[j]?.job_type}_${el?.future_jobs[j]?.period_ended}`?.slice(
                      0,
                      15
                    ) + "..."
                  : `${el?.future_jobs[j]?.job_type}_${el?.future_jobs[j]?.period_ended}`,
              fullTitle: `${el?.future_jobs[j]?.job_type}_${el?.future_jobs[j]?.period_ended}`,

              backgroundColor: "#e2e4ed",
              textColor: "#6e7491",
              //  color: "green",
              //  textColor:el?.jobs[i]?.job_status==="Closed"?"#e3efff":"#fde0d3",
              fontWeight: 500,
              borderColor: "#e2e4ed",
              cursor: "pointer",
              future: true,
            });
          }
        }
      });

      setEventData(eventArray);
    } else {
      setEventData([]);
    }

    // setEventData()
  }, [complianceCalendarList]);

  let buttonId = document.getElementsByClassName("fc-button-group")[0];
  buttonId?.addEventListener("click", () => {
    let calendarId: any = document.getElementsByClassName("fc-toolbar-title");
    if (calendarId[0]?.innerText) {
      setMonthData(calendarId[0]?.innerText);
      setYearData(calendarId[0]?.innerText.split(" ")[1]);
    }
  });

  let buttonTodayId = document.getElementsByClassName("fc-today-button")[0];
  buttonTodayId?.addEventListener("click", () => {
    let calendarId: any = document.getElementsByClassName("fc-toolbar-title");
    if (calendarId[0]?.innerText) {
      setMonthData(calendarId[0]?.innerText);
      setYearData(calendarId[0]?.innerText.split(" ")[1]);
    }
  });

  useEffect(() => {
    setMonthData(currentMonth());
    setYearData(currentYear()?.toString());
  }, []);

  useEffect(() => {
    let month = monthData.split(" ");
    let year = yearData;
    let payload = {
      month: month[0]?.slice(0, 3).toLowerCase(),
      year: year,
      client_code: clientName?.value,
      token,
    };

    if (token && month && year && clientName?.value) {
      dispatchComplianceCalenderListData(payload);
    }
  }, [monthData, yearData, clientName]);

  const handleClientChanges = (data: any) => {
    // dispatchResetSingleRecurringJobsDetails()
    setClientName({
      value: data?.value,
      label: data?.label,
    });
    // setClientCodeError("")
  };

  const handleErrorModal = () => {
    if (success === 0 || authSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired! Please login again."
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      }
      if (authStatusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message="Session Expired! Please login again."
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={authStatusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      } else if (!!authError && authStatusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!authError}
            title="Error"
            message={authError}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
            }}
          />
        );
      }
    }

    return false;
  };
  const handleTabChange = (tabs: string) => {
    setActiveTab(tabs);
  };
  const renderTabs = () => {
    const filterTabs: TabsType[] = tabs;
    const finalTab = filterTabs?.map((tab: TabsType) => {
      return (
        <div
          key={tab?.label}
          className="pointer mr-2"
          onClick={() => {
            handleTabChange(tab?.label);
          }}
        >
          <div
            style={{
              padding: "12px 5px 12px 5px",
              color: activeTab === tab?.label ? "#dd4433" : "",
              fontSize: "14px",
            }}
            className={`tab-header ${activeTab === tab?.label ? "active" : ""}`}
          >
            {tab?.name}
          </div>
          <div
            className={`${
              activeTab === tab?.label
                ? "active-tab-bottom-border"
                : "not-active-tab-bottom-border"
            }`}
          ></div>
        </div>
      );
    });
    return finalTab;
  };
  const handleEventContent = (arg: any) => {
    const { event } = arg;
    const tooltipContent = event?._def?.extendedProps?.fullTitle;
    return (
      <>
        {/* <div>{event?._def?.title}</div> */}
        <div>
          {event?._def?.title?.length > 10 && (
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip id={event.id}>{tooltipContent}</Tooltip>}
            >
              <span className="event-tooltip">{event?._def?.title}</span>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };
  const renderAllComments = () => {
    const finalComments = jobProgressCommentsList?.map(
      (data: JobProgressCommentType, index: number) => {
        let finalName = !data?.first_name?.length
          ? `${data?.company_name?.slice(0, 25)}...`
          : `${data.first_name} ${data?.last_name}`;
        return (
          <Comments
            key={index}
            commenterName={finalName}
            commentTime={data?.created_at}
            commentText={data?.comment}
            image={data?.profile_pic}
          />
        );
      }
    );
    return finalComments;
  };
  const renderAllRecordings = () => {
    const finalComments = documentsLinkList?.map((data: any, index: number) => {
      let finalName = !data?.first_name?.length
        ? `${data?.company_name?.slice(0, 25)}...`
        : `${data.first_name} ${data?.last_name}`;
      return (
        <Comments
          key={index}
          type={"recording"}
          commenterName={finalName}
          commentTime={data?.created_at}
          commentText={data?.link}
          image={data?.profile_pic}
          clientName={clientName}
        />
      );
    });
    return finalComments;
  };

  return (
    <>
      <div className="row">
        <div className="col-md-6">
          <CommonHeader title={`Compliance Calendar`} />
        </div>
      </div>
      <ContentArea>
        {/* <div className="row"> */}
        {/* <h4 style={{ fontSize: "20px", fontWeight: "500" }}>
          Compliance Calendar
        </h4> */}
        {/* </div> */}

        <div className="complineance">
          <div
            className="row"
            style={{ justifyContent: "space-between", alignItems: "center" }}
          >
            <div className="col-md-3">
              <label
                htmlFor="Select Client"
                className="mb-2"
                style={{ whiteSpace: "nowrap" }}
              >
                Please select client to see jobs in calendar
              </label>

              <Select
                options={finalClientList}
                // className={`${clientCodeError?"error-border rounded":""}`}
                value={clientName}
                onChange={handleClientChanges}
                isSearchable={true}
                isLoading={authFetching}
                onInputChange={(e) => {
                  setText(e);
                }}
              />
            </div>
            <div className="row">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                  gap: "5px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#2D7FE3",
                    padding: "8px 10px",
                    border: "none",
                    borderRadius: "6px",
                  }}
                  disabled
                ></button>
                Open Jobs
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                  gap: "5px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#E0794A",
                    padding: "8px 10px",
                    border: "none",
                    borderRadius: "6px",
                  }}
                  disabled
                ></button>
                Overdue Jobs{" "}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                  gap: "5px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#6E7491",
                    padding: "8px 10px",
                    border: "none",
                    borderRadius: "6px",
                  }}
                  disabled
                ></button>
                Future Jobs{" "}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "52px",
                  gap: "5px",
                }}
              >
                <button
                  style={{
                    backgroundColor: "#ffffff",
                    padding: "8px 9px",
                    border: "1px solid",
                    borderRadius: "6px",
                  }}
                  disabled
                ></button>
                Closed Jobs
              </div>
            </div>
          </div>

          <Fullcalendar
            plugins={[dayGridPlugin]}
            initialView={"dayGridMonth"}
            events={eventData}
            eventClick={handleClick}
            eventContent={handleEventContent}
            height={"90vh"}
            headerToolbar={{
              start: "",
              left: "title",
              end: "today prev,next",
              //   right:"title"
            }}
            buttonText={{
              today: "Today",
            }}
          />
          {eventDetails && (
            <Modal
              centered
              isOpen={eventDetails}
              toggle={() => setEventDetails(!eventDetails)}
              style={{ minWidth: "555px" }}
            >
              <ModalHeader
                id="cross-cut"
                className="pt-3 pl-4 pb-3"
                toggle={() => setEventDetails(!eventDetails)}
              >
                Job Summary
              </ModalHeader>
              <ModalBody style={{ paddingBottom: "0rem" }}>
                <div style={{ padding: "10px 10px 13px 10px" }}>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "23px",
                      justifyContent: "flex-start",
                      gap: "25px",
                    }}
                  >
                    <div className="model-left-name">
                      {eventDetailsClick?.data?.job_id
                        ? "Job ID & Type"
                        : "Type"}{" "}
                    </div>
                    <div className="modal-right-value">
                      {`${
                        eventDetailsClick?.data?.job_id
                          ? eventDetailsClick?.data?.job_id
                          : ""
                      }${eventDetailsClick?.data?.job_id ? "_" : ""}${
                        eventDetailsClick?.data?.job_type
                      }`}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "23px",
                      justifyContent: "flex-start",
                      gap: "25px",
                    }}
                    className="mt-3"
                  >
                    <div className="model-left-name">Description</div>
                    <div className="modal-right-value">
                      {eventDetailsClick?.data?.job_description}
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "23px",
                      justifyContent: "flex-start",
                      gap: "25px",
                    }}
                    className="mt-3"
                  >
                    <div className="model-left-name">Start Date</div>
                    <div
                      className="modal-right-value"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {eventDetailsClick?.data?.target_start_date && (
                        <img
                          src={CalanderGrayIcon}
                          alt="calandar"
                          className="mr-2"
                        />
                      )}
                      <div>
                        {" "}
                        {eventDetailsClick?.data?.target_start_date
                          ? eventDetailsClick?.data?.target_start_date
                          : ""}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "23px",
                      justifyContent: "flex-start",
                      gap: "25px",
                    }}
                    className="mt-3"
                  >
                    <div className="model-left-name">Target End Date</div>
                    <div
                      className="modal-right-value"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {eventDetailsClick?.data?.target_end_date && (
                        <img
                          src={CalanderGrayIcon}
                          alt="calandar"
                          className="mr-2"
                        />
                      )}
                      <div>{eventDetailsClick?.data?.target_end_date}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "23px",
                      justifyContent: "flex-start",
                      gap: "25px",
                    }}
                    className="mt-3"
                  >
                    <div className="model-left-name">Period End Date</div>
                    <div
                      className="modal-right-value"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      {eventDetailsClick?.data?.period_ended && (
                        <img
                          src={CalanderGrayIcon}
                          alt="calandar"
                          className="mr-2"
                        />
                      )}
                      <div>{eventDetailsClick?.data?.period_ended}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      lineHeight: "23px",
                      justifyContent: "flex-start",
                      gap: "25px",
                    }}
                    className="mt-3"
                  >
                    <div className="model-left-name">Job Manager</div>
                    <div
                      className="modal-right-value"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {(eventDetailsClick?.data?.job_manager?.profile_pic
                        ?.file_url ||
                        eventDetailsClick?.data?.job_manager?.first_name) && (
                        <CircularAvatar
                          image={
                            eventDetailsClick?.data?.job_manager?.profile_pic
                              ?.file_url
                          }
                          name={`${eventDetailsClick?.data?.job_manager?.first_name} ${eventDetailsClick?.data?.job_manager?.last_name}`}
                        />
                      )}
                      <span className="ml-2">
                        {`${
                          eventDetailsClick?.data?.job_manager?.first_name
                            ? eventDetailsClick?.data?.job_manager?.first_name
                            : ""
                        } ${
                          eventDetailsClick?.data?.job_manager?.last_name
                            ? eventDetailsClick?.data?.job_manager?.last_name
                            : ""
                        }`}{" "}
                      </span>
                    </div>
                  </div>
                  <div
                    style={{ display: "flex", lineHeight: "23px", gap: "25px" }}
                    className="mt-3"
                  >
                    <div className="model-left-name">Currently Responsible</div>
                    <div
                      className="modal-right-value"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {(eventDetailsClick?.data?.currently_responsible
                        ?.profile_pic?.file_url ||
                        eventDetailsClick?.data?.currently_responsible
                          ?.first_name) && (
                        <CircularAvatar
                          image={
                            eventDetailsClick?.data?.currently_responsible
                              ?.profile_pic?.file_url
                          }
                          name={`${eventDetailsClick?.data?.currently_responsible?.first_name} ${eventDetailsClick?.data?.currently_responsible?.last_name}`}
                        />
                      )}
                      <span className="ml-2">
                        {`${
                          eventDetailsClick?.data?.currently_responsible
                            ?.first_name
                            ? eventDetailsClick?.data?.currently_responsible
                                ?.first_name
                            : ""
                        } ${
                          eventDetailsClick?.data?.currently_responsible
                            ?.last_name
                            ? eventDetailsClick?.data?.currently_responsible
                                ?.last_name
                            : ""
                        }`}{" "}
                      </span>
                    </div>
                  </div>
                  {/*  */}
                  {showComments && (
                    <div className="row">
                      <div className="col-md-12 pl-0">
                        <div
                          style={{
                            borderRadius: "5px 5px 0 0",
                            padding: "0px 15px",
                          }}
                        >
                          <div
                            className="d-flex"
                            style={{
                              borderBottom: "2px solid #bfcbe1",
                              paddingTop: "17px",
                            }}
                          >
                            {renderTabs()}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </ModalBody>
              {showComments && (
                <ModalFooter style={{ borderTop: "none", paddingTop: "0rem" }}>
                  {activeTab === "allComments" ? (
                    jobProgressCommentsFetching ? (
                      <TableLoader Rows={10} ColumnPerRow={7} />
                    ) : !!jobProgressCommentsList &&
                      jobProgressCommentsList.length > 0 ? (
                      <div className="w-100 comment-area">
                        {renderAllComments()}
                      </div>
                    ) : (
                      <div className="w-100 text-center due-date-text">
                        No Comments!
                      </div>
                    )
                  ) : jobProgressCommentsFetching ? (
                    <TableLoader Rows={10} ColumnPerRow={7} />
                  ) : !!documentsLinkList && documentsLinkList.length > 0 ? (
                    <div className="w-100 comment-area">
                      {renderAllRecordings()}
                    </div>
                  ) : (
                    <div className="w-100 text-center due-date-text">
                      No Links!
                    </div>
                  )}
                </ModalFooter>
              )}
            </Modal>
          )}
        </div>
      </ContentArea>
      {fetching && <Loader />}
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  authFetching: state.auth.fetching,
  authError: state.auth.error,
  authStatusCode: state.auth.statusCode,
  authSuccess: state.auth.success,
  authMessage: state.auth.message,
  token: state.auth.token,
  complianceCalendarList: state.complianceCalendar.complianceCalendarList,
  fetching: state.complianceCalendar.fetching,
  message: state.complianceCalendar.message,
  error: state.complianceCalendar.error,
  loginData: state.auth.loginData,
  success: state.complianceCalendar.success,
  statusCode: state.complianceCalendar.statusCode,
  assignedClientsToUserList: state.auth.assignedClientsToUserList,
  jobProgressCommentsFetching: state.jobs.jobProgressCommentsFetching,
  jobProgressCommentsList: state.jobs.jobProgressCommentsList,
  jobProgressCommentsSuccess: state.jobs.jobProgressCommentsSuccess,
  documentsLinkList: state.jobs.documentsLinkList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchComplianceCalenderListData: (
    data: GetComplianceCalendarPayloadType
  ) => dispatch(getComplianceCalendarAction(data)),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  resetComplianceCalendarList: () => dispatch(resetComplianceCalendarList()),
  dispatchResetAuthSuccess: () => dispatch(resetAuthSuccess()),
  dispatchResetAuthMessage: () => dispatch(resetAuthMessage()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetAssignedClientsToUserList: () =>
    dispatch(resetAssignedClientsToUserList()),
  disptahcResetComplianceCalendarFetching: () =>
    dispatch(resetComplianceCalendarFetching()),
  dispatchResetComplianceCalendarSuccess: () =>
    dispatch(resetComplianceCalendarSuccess()),
  dispatchResetComplianceCalendarMessage: () =>
    dispatch(resetComplianceCalendarMessage()),
  dispatchResetComplianceCalendarStatusCode: () =>
    dispatch(resetComplianceCalendarStatusCode()),
  dispatchResetComplianceCalendarError: () =>
    dispatch(resetComplianceCalendarError()),
  dispatchGetAllJobProgressCommentsAction: (
    data: GetJobProgressCommentsPayload
  ) => dispatch(getJobCommentsDetailsAction(data)),
  dispatchGetDocumentsLinkAction: (data: GetAllDocumentsLinkPayloadType) =>
    dispatch(getJobLinksDetailsAction(data)),
  dispatchResetJobProgressCommentsListing: () =>
    dispatch(resetJobProgressCommentsListing()),
  dispatchResetJobProgressCommentsSuccess: () =>
    dispatch(resetJobProgressCommentsSuccess()),
  dispatchResetDocumentsLinkList: () => dispatch(resetDocumentsLinkList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ComplianceCalendar);
